import { UseQueryResult, useQuery } from '@tanstack/react-query';

import get from '../data/theme-service';
import { ThemePageType } from '../types';

const useTheme = (employerCode: string | null, theme: string, language: string): UseQueryResult<ThemePageType, Error> =>
  useQuery(['theme', theme, language], () => get(employerCode, theme, language), {
    staleTime: undefined,
  });

export default useTheme;
